/** Values shared by database, API and UI. Changing one of these is a migration. */
export const ROLES = ['OWNER', 'ADMIN', 'MANAGER', 'MEMBER', 'GUEST', 'VIEWER'];
/** Higher number wins. Used by the authorize middleware and the UI alike. */
export const ROLE_RANK = {
    VIEWER: 10,
    GUEST: 20,
    MEMBER: 30,
    MANAGER: 40,
    ADMIN: 50,
    OWNER: 60,
};
export const ITEM_STATUSES = ['NOT_STARTED', 'IN_PROGRESS', 'BLOCKED', 'DONE', 'CANCELLED'];
export const HEALTH = ['ON_TRACK', 'AT_RISK', 'BLOCKED', 'OVERDUE'];
export const PRIORITIES = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];
export const INVITATION_STATUSES = ['PENDING', 'ACCEPTED', 'REVOKED', 'EXPIRED'];
export const ACTIVITY_VERBS = [
    'CREATED',
    'UPDATED',
    'DELETED',
    'STATUS_CHANGED',
    'ASSIGNED',
    'COMMENTED',
    'INVITED',
    'JOINED',
    'SCHEDULED',
];
//# sourceMappingURL=enums.js.map